export default __webpack_public_path__ + "static/media/voting-box.417ca45d.png";